import { LAYER_GEOMETRY_TYPE } from '@/lib/db-constants';
import { LayerGeometryType } from '@/lib/db-row-types';

export const BOUNDARY_CONFIG = {
  'US Census Tracts': {
    id: '4ec6a73f-3c2a-4b2d-994a-735798c03abe',
    matchColumns: ['geoid'],
    priority: 1,
  },
  'US Counties': {
    id: 'cd75c3ed-fb22-45b5-8296-ec3154913e0d',
    matchColumns: ['geoid', 'county'],
    priority: 2,
  },
  'US States': {
    id: '6cedb7ac-5791-421e-bfb9-c1d0e9433620',
    matchColumns: ['state'],
    priority: 3,
  },
} as const;

export const BOUNDARY_TYPES: Record<string, string> = Object.fromEntries(
  Object.entries(BOUNDARY_CONFIG).map(([key, value]) => [key, value.id])
);

export const GEOMETRY_TYPES = {
  COORDINATES: 'coordinates',
  ADDRESS: 'address',
  AREAS: 'areas',
} as const;

export const GEOMETRY_TYPES_MAP = new Map<
  (typeof GEOMETRY_TYPES)[keyof typeof GEOMETRY_TYPES],
  LayerGeometryType
>([
  [GEOMETRY_TYPES.COORDINATES, LAYER_GEOMETRY_TYPE.POINT],
  [GEOMETRY_TYPES.ADDRESS, LAYER_GEOMETRY_TYPE.POINT],
  [GEOMETRY_TYPES.AREAS, LAYER_GEOMETRY_TYPE.POLYGON],
]);

export const FEATURE_MATCH_STATUS = {
  OK: 'ok',
  NOT_FOUND: 'not_found',
} as const;

export const FEATURE_MATCH_DISPLAY = {
  OK: 'Matched',
  NOT_FOUND: 'Not Found',
  NULL: 'No Status',
} as const;

export const FEATURE_MATCH_COLUMN_NAME = 'Feature match';
